import React, { useState, useContext } from 'react';
import Collapsible from 'react-collapsible';
import {LoadingButton, LoadingFormButton} from '../../../shared/loading-button';
import QuoteContext from "../../quote-context";
import axios from "axios/index";

const Login = ({ processForm }) => {
	
	const {navigation, navigationDispatcher, formDispatcher, formData } = useContext(QuoteContext);

	const[passwordReveal, setPasswordReveal] = useState(false);
	const[recoveryTabActive, setRecoveryTabActive] = useState(false);
	const[recoveryEmail, setRecoveryEmail] = useState('');
	const[recoveryLoader, setRecoveryLoader] = useState(false);
	const[recoverySuccess, setRecoverySuccess] = useState('');

	const _defaultError = 'Unable to send recovery email, please try again later. If this problem persists please contact us';

	const handleChange = ( e ) => {
		formDispatcher({type: "UPDATE_FIELD", key: e.target.name, value: e.target.value});
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		processForm();
	}

	const submitPasswordRecovery = () => {
	

		navigationDispatcher({ 
			type: 'TRACK_EVENT', 
			action: 'event',
			category: 'form_submit',
			name: 'password-recovery',
			trigger: 'web-js',
			data:  recoveryEmail.replace(/\w/g, "*")
		});
		

		navigationDispatcher({type: "RESET_ERRORS" });

		setRecoveryLoader(true);

		const recoveryFormData = new FormData();
		recoveryFormData.append( 'email', recoveryEmail );

		axios.post( "/reset/json", recoveryFormData ).then( response => {
			if( response.data.isValid ) {
				setRecoverySuccess( 'Thank you. If the email address you entered exists on our system, you will be sent a password reset link via email.' );
			} else {
				navigationDispatcher({type: "RAISE_ERROR", message: response.data.message || _defaultError, code: null });
				
				navigationDispatcher({ 
					type: 'TRACK_EVENT', 
					action: 'error',
					category: 'validation-errors',
					name: 'passsword-recovery-submit',
					trigger: 'web-js',
					data: response.data.message
				});
			
			}
		}).catch( err => {
			navigationDispatcher({type: "RAISE_ERROR", message: _defaultError, code: null });
			
			navigationDispatcher({ 
				type: 'TRACK_EVENT', 
				action: 'error',
				category: 'validation-errors',
				name: 'passsword-recovery-submit',
				trigger: 'web-js',
				data:  err.response.data.message
			});
			
		}).then(()=>{
			setRecoveryLoader(false);
		});

	}

	return (
			<form onSubmit={handleSubmit} id="quote-form-v3">
			
				<div className={navigation.error.code == 'ERR_EMAIL' || navigation.error.code == 'ERR_LOGINEMAIL_FORMAT' ? `field-error` : null}>
					<label className="form-label"><span>Your email:</span></label>
					<input className="form-input radius" type="text" placeholder="example@youremail.com" name="email" value={formData.email} onChange={handleChange} />
				</div>

				<div className={navigation.error.code == 'ERR_PASSWORD' ? `field-error` : null }>
					<label className="form-label"><span>Your password:</span></label>
					<div className="form-password">
						<input
						className="form-input radius"
						type={passwordReveal ? "text" : "password"}
						placeholder="Enter your password"
						name="password"
						value={formData.password}
						onChange={handleChange} 
						/>
						<div onClick={() => setPasswordReveal(!passwordReveal)}>
							{passwordReveal ? <span className="icon icon-show black"></span> : <span className="icon icon-hide black"></span>}
						</div>
					</div>
				</div>
				
				<label htmlFor="promo1" className="button plain auto-dsk-up toggle mg-b">Got a promo code?</label>

				<input type="checkbox" id="promo1" className="hide-input"/>
				<div className="toggle-content">
					<div className={navigation.error.code == 'PROMOTION_CODE' ? `field-error` : null}>
						<label className="form-label"><span>Promo code (optional)</span></label>
						<input className="form-input radius" type="text" name="code" value={formData.code} onChange={handleChange} data-hj-whitelist />
					</div>
				</div>

				<div className="mg-b">
				
					<LoadingFormButton
						value="get price"
						processing={navigation.processing}
						buttonClass="button primary radius fit-content"
					/>
					
				</div>

				<label htmlFor="password" className="button plain auto-dsk-up toggle mg-b">Forgotten your password?</label>

				<input type="checkbox" id="password" className="hide-input"/>
				<div className="toggle-content">
					<div className="align-content dir-col">
						<p className="mg-b">Confirm your email address in the field below to receive your validation code by e-mail:</p>

						<label className="form-label"><span>Email address</span></label>
						<input className="form-input radius" type="text" name="recoveryEmail" value={recoveryEmail} onChange={e => setRecoveryEmail(e.target.value)} />

						<LoadingButton
							value="Reset password"
							submit={submitPasswordRecovery}
							processing={recoveryLoader}
							buttonClass="button primary radius fit-content"
						/>
					</div>
				</div>

				{recoverySuccess ? (
					<div className="quote-success">
						{recoverySuccess}
					</div>
				) : null }

			</form>
		)

}

export default Login;
